/**
 * @generated SignedSource<<62a932fb1ec15b9c8f06f4eb6dc00584>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type ConferenceCallProvider = "HANGOUTS_MEET" | "MS_TEAMS" | "SKYPE_FOR_BUSINESS" | "UNKNOWN" | "WEBEX" | "ZOOM";
import { FragmentRefs } from "relay-runtime";
export type CalendarEvents_meetingInfoModalEvent$data = {
  readonly conferenceCalls: ReadonlyArray<{
    readonly phoneNumber: string | null;
    readonly pin: string | null;
    readonly provider: ConferenceCallProvider;
    readonly url: string;
  }>;
  readonly end: string | null;
  readonly guid: string;
  readonly id: string;
  readonly isAllDay: boolean;
  readonly isHidden: boolean | null;
  readonly isOrganizer: boolean | null;
  readonly location: string | null;
  readonly recurrenceRule: ReadonlyArray<string | null> | null;
  readonly start: string | null;
  readonly title: string;
  readonly " $fragmentType": "CalendarEvents_meetingInfoModalEvent";
};
export type CalendarEvents_meetingInfoModalEvent$key = {
  readonly " $data"?: CalendarEvents_meetingInfoModalEvent$data;
  readonly " $fragmentSpreads": FragmentRefs<"CalendarEvents_meetingInfoModalEvent">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "CalendarEvents_meetingInfoModalEvent"
};

(node as any).hash = "0f7cc186b353341badab20f032578899";

export default node;
